/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as ActionTypes from './actionTypes';

const initialState = {
  searchResult: [],
  rebateProgram: '',
  rebateProgramList: [],
  searchScreenReduxObj: {},
  selectedPlanType: '',
  isLoading: false,
  planType: [],
  rebateProgramValue: '',
  rebateProgramNameValue: '',
  errors: [],
  fromDateValue: '',
  toDateValue: '',
  displayObj: {
    fromDateValue: '',
    toDateValue: '',
    searchResult: [],
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_INTEREST_RECIEVED_REPORT:
      const displayObj = {
        ...state.displayObj,
        searchResult: action.payload,
      };
      return { ...state, searchResult: action.payload, displayObj };
    case ActionTypes.SET_SELECTED_INPUT_RECIEVED:
      return { ...state, ...action.payload };
    case ActionTypes.REFRESH_INTEREST_RECIEVED:
      return {
        ...initialState,
        displayObj: state.displayObj,
      };
    case ActionTypes.IS_LOADING:
      return { ...state, isLoading: action.isLoading };
    case ActionTypes.SEARCH_SCREEN_REDUX_DATA:
      return { ...state, searchScreenReduxObj: action.searchScreenReduxObj };
    default:
      return state;
  }
};

export default reducer;
